/* eslint-disable no-debugger, no-console */

import { inject, provide, reactive } from "vue";

const DataContext = Symbol("DataContext");

export function useDataProvider() {
  const plansData = reactive({
    planItems: [],
    eduLevelItems: [],
    subjectItems: [],
    sdgItems: [],
    planLookupTable: {},
    page: {
      currentPage: 0,
      pageSize: 9,
    },
    filteredPlans: [],
    afterEdu: "",
    afterSubject: "",
    afterSDG: "",
    afterArea: "",
    afterSearchKey: "",
    selectedResultShow: false,
  });
  const sdgPlansData = reactive({
    planItems: [],
    page: {
      currentPage: 0,
      pageSize: 9,
    },
    videoModal: false,
    videoModalSrc: null,
  });

  fetch("/lesson-plans.json")
    .then((response) => response.json())
    .then((data) => {
      plansData.planItems = data;
      plansData.filteredPlans = data;

      for (let i = 0; i < plansData.planItems.length; i++) {
        let plan = plansData.planItems[i];
        fetch(
          `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${plan.youtubeLink}`
        ).then(function(response) {
          plan.validYoutubeLink =
            response.status === 400 ||
            response.status === 401 ||
            response.status === 403 ||
            response.status === 404
              ? false
              : true;
        });
        if (plan.imageLink.length !== 0) {
          plan.imgFileExists = true;
        } else {
          plan.imgFileExists = false;
        }
        plansData.planLookupTable[plan.id] = plan;
      }
    });

  fetch("/education-levels.json")
    .then((response) => response.json())
    .then((data) => {
      plansData.eduLevelItems = data;
    });

  fetch("/subjects.json")
    .then((response) => response.json())
    .then((data) => {
      plansData.subjectItems = data;
    });

  fetch("/sdg.json")
    .then((response) => response.json())
    .then((data) => {
      plansData.sdgItems = data;
    });

  fetch("/sdg-plans.json")
    .then((response) => response.json())
    .then((data) => {
      sdgPlansData.planItems = data;
      // for (let i = 0; i < sdgPlansData.planItems.length; i++) {
      //   let plan = sdgPlansData.planItems[i];
      //   fetch(
      //     `https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${plan.downloadLink}`
      //   ).then(function(response) {
      //     plan.validDownloadLink =
      //       response.status === 400 ||
      //       response.status === 401 ||
      //       response.status === 403 ||
      //       response.status === 404
      //         ? false
      //         : true;
      //   });
      //   if (plan.imgUrl.length !== 0) {
      //     plan.imgFileExists = true;
      //   } else {
      //     plan.imgFileExists = false;
      //   }
      //   sdgPlansData.planLookupTable[plan.id] = plan;
      // }
    });

  const reselected = () => {
    plansData.selectedResultShow = false;
  };
  const filterPlansComputed = (
    selectedLevel,
    selectedSubject,
    selectedSDG,
    selectedArea,
    searchKeyWord
  ) => {
    //每重新搜尋,就歸零重來
    plansData.filteredPlans = [];
    plansData.page.currentPage = 0;
    plansData.selectedResultShow = true;

    // 判斷學段
    plansData.planItems.forEach((element) => {
      if (selectedLevel === "" || selectedLevel === "全部階段") {
        plansData.filteredPlans.push(element);
      } else {
        if (element.grade.indexOf(selectedLevel) !== -1) {
          plansData.filteredPlans.push(element);
        }
      }
    });

    //判斷科目
    if (selectedSubject !== "" && selectedSubject !== "全部科目") {
      for (let i = 0; i < plansData.filteredPlans.length; i++) {
        if (
          plansData.filteredPlans[i].subject.indexOf(selectedSubject) === -1
        ) {
          plansData.filteredPlans.splice(i, 1);
          i--;
        }
      }
    }

    //判斷SDG
    if (selectedSDG !== "" && selectedSDG !== "全部目標") {
      const sdgCode = selectedSDG.split(" ")[0];
      for (let i = 0; i < plansData.filteredPlans.length; i++) {
        // 將字串轉為陣列
        const targetArray = plansData.filteredPlans[i].SDGtarget.split(",");

        // 檢查是否包含選擇的 SDG
        if (!targetArray.includes(sdgCode)) {
          plansData.filteredPlans.splice(i, 1);
          i--;
        }
      }
    }

    //判斷地區
    if (selectedArea === "離島") {
      for (let i = 0; i < plansData.filteredPlans.length; i++) {
        if (
          plansData.filteredPlans[i].city.indexOf("金門縣") === -1 &&
          plansData.filteredPlans[i].city.indexOf("澎湖縣") === -1 &&
          plansData.filteredPlans[i].city.indexOf("連江縣") === -1
        ) {
          plansData.filteredPlans.splice(i, 1);
          i--;
        }
      }
    } else if (selectedArea !== "" && selectedArea !== "全臺") {
      for (let i = 0; i < plansData.filteredPlans.length; i++) {
        if (plansData.filteredPlans[i].city.indexOf(selectedArea) === -1) {
          plansData.filteredPlans.splice(i, 1);
          i--;
        }
      }
    }

    //判斷關鍵字搜尋
    if (searchKeyWord !== "") {
      for (let i = 0; i < plansData.filteredPlans.length; i++) {
        if (plansData.filteredPlans[i].name.indexOf(searchKeyWord) === -1) {
          plansData.filteredPlans.splice(i, 1);
          i--;
        }
      }
    }

    plansData.afterEdu = selectedLevel;
    plansData.afterSubject = selectedSubject;
    plansData.afterSDG = selectedSDG;
    plansData.afterArea = selectedArea;
    plansData.afterSearchKey = searchKeyWord;
  };

  provide(DataContext, {
    plansData,
    filterPlansComputed,
    reselected,
    sdgPlansData,
  });
}

export function useDataContext() {
  const context = inject(DataContext);

  if (!context) {
    throw new Error("useCounterContext must be used with useCounterProvider");
  }

  return context;
}
